const OPTIMIZABLE_HOSTS = new Set([
  'orcar-erp-image.s3.ap-northeast-2.amazonaws.com',
  'sumcar-prod.s3.ap-northeast-2.amazonaws.com',
]);

/**
 * 차종 원본 이미지(평균 380KB)를 Vercel 이미지 최적화(`/_vercel/image`)로
 * 화면 크기에 맞춘 WebP 로 받는 주소를 만든다.
 * 너비·품질·호스트는 vercel.json 의 `images` 설정과 같아야 한다.
 * 로컬 개발 서버에는 이 경로가 없으므로 원본 주소를 그대로 쓴다.
 */
export const optimizedImageUrl = (src: string | undefined) => {
  if (!src || !import.meta.env.PROD) return src;
  try {
    if (!OPTIMIZABLE_HOSTS.has(new URL(src).hostname)) return src;
  } catch {
    return src;
  }
  return `/_vercel/image?url=${encodeURIComponent(src)}&w=640&q=75`;
};
